import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV } from "@/constants/testIds";

const links = [
  { id: "manuale", label: "Il Manuale", testId: NAV.linkManuale },
  { id: "benefici", label: "Benefici", testId: NAV.linkBenefici },
  { id: "anteprima", label: "Anteprima", testId: NAV.linkAnteprima },
  { id: "recensioni", label: "Recensioni", testId: NAV.linkRecensioni },
  { id: "faq", label: "FAQ", testId: NAV.linkFaq },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-[#ecfef7]/90 backdrop-blur-xl border-b border-[#5982c5]/10 shadow-[0_4px_20px_rgb(0,0,0,0.03)]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-[72px] flex items-center justify-between">
        <button
          data-testid={NAV.logo}
          onClick={() => scrollTo("hero")}
          className="flex items-center gap-2 shrink-0"
          aria-label="PeakStudy home"
        >
          <img src="/logo-icon.png" alt="PeakStudy" className="h-10 w-10 object-contain" />
          <span className="font-heading text-xl font-extrabold tracking-tight">
            <span className="text-[#5982c5]">Peak</span>
            <span className="text-[#f0d203]">Study</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={l.testId}
              onClick={() => scrollTo(l.id)}
              className="text-sm font-semibold text-[#4b5563] hover:text-[#5982c5] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid={NAV.ctaBuy}
          onClick={() => scrollTo("checkout")}
          className="hidden md:flex bg-[#f0d203] text-[#1a1a1a] hover:bg-[#dcb902] hover:-translate-y-0.5 hover:shadow-lg transition-all duration-300 font-bold px-6 py-2.5 rounded-full text-sm"
        >
          Acquista Ora
        </button>

        <button
          data-testid={NAV.mobileToggle}
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 text-[#1f2937]"
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#ecfef7] border-b border-[#5982c5]/10 px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => { scrollTo(l.id); setOpen(false); }}
              className="text-left text-base font-semibold text-[#1f2937]"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => { scrollTo("checkout"); setOpen(false); }}
            className="bg-[#f0d203] text-[#1a1a1a] font-bold px-6 py-3 rounded-full"
          >
            Acquista Ora
          </button>
        </div>
      )}
    </header>
  );
}
